<template>
  <div class="-z-10">
    <div
      class="absolute border-2 border-ol-primary-10 h-[427px] w-[425px] rounded-full top-[-190px] -right-60"
    />
    <div
      class="w-[356px] h-[359px] top-[-160px] right-[-210px] absolute rounded-full bg-ol-primary-10"
    />
    <div
      class="w-[113px] bottom-10 left-[-170px] rounded-full h-[116px] absolute bg-ol-secondary-20"
    />
  </div>
</template>
